import PropTypes from "prop-types";

// Layouts
import DoubleInput from "@Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Duration",
							min: 0,
							decimalsEditable: true,
							decimals: 2,
							delta: 0.01,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Duration",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Duration",
							min: 0,
							decimalsEditable: true,
							decimals: 2,
							delta: 0.01,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Duration",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
